<script setup>
import { ref } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';

defineProps({
  placement: {
    type: String,
    default: 'top',
  },
});

const dropdownMenuRef = ref(null);

const dropdownMenuButtons = () => {
  return dropdownMenuRef.value.querySelectorAll(
    'li.dropdown-menu__item:not([aria-disabled="true"]) button:not(:disabled), li.dropdown-menu__item:not([aria-disabled="true"]) a[href]'
  );
};

const getActiveButtonIndex = menuButtons => {
  const focusedButton = dropdownMenuRef.value.querySelector(
    'li.dropdown-menu__item :focus'
  );
  return Array.from(menuButtons).indexOf(focusedButton);
};

const focusButton = (menuButtons, newIndex) => {
  if (menuButtons.length === 0) return;
  menuButtons[newIndex].focus();
};

const focusPreviousButton = menuButtons => {
  const activeIndex = getActiveButtonIndex(menuButtons);
  const newIndex = activeIndex >= 1 ? activeIndex - 1 : menuButtons.length - 1;
  focusButton(menuButtons, newIndex);
};

const focusNextButton = menuButtons => {
  const activeIndex = getActiveButtonIndex(menuButtons);
  const newIndex = activeIndex === menuButtons.length - 1 ? 0 : activeIndex + 1;
  focusButton(menuButtons, newIndex);
};

const keyboardEvents = {
  ArrowUp: {
    action: () => focusPreviousButton(dropdownMenuButtons()),
    allowOnFocusedInput: true,
  },
  ArrowDown: {
    action: () => focusNextButton(dropdownMenuButtons()),
    allowOnFocusedInput: true,
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <ul
    ref="dropdownMenuRef"
    :data-placement="placement"
    class="m-0 flex min-w-0 list-none flex-col gap-1 p-0"
  >
    <slot />
  </ul>
</template>
